import React from "react"
import dayjs from "dayjs"
import address_drop_blue from "../../../../../assets/icons/address_drop_blue.svg"
import {useAppSelector} from "../../../../../hooks/redux"
import classes from "./OrderInfo.module.scss"
import CopyAddress from "../../../../generic/other/CopyAddress"

function OrderInfo() {

  const {order, paymentTypes} = useAppSelector(state => state.order)
  const payment = paymentTypes.find(item => item.id === order.payment_type_id)

  const addressFrom = []
  const addressFromShort = []

  if (order.city_from){
    addressFrom.push(order.city_from)
    addressFromShort.push(order.city_from)
  }

  if (order.address_from) {
    addressFrom.push(order.address_from)
    addressFromShort.push(order.address_from)
  }

  if (order.entrance_from)
    addressFrom.push(`${order.entrance_from} подъезд`)

  if (order.floor_from)
    addressFrom.push(`${order.floor_from} эт.`)

  if (order.flat_from)
    addressFrom.push(`кв. ${order.flat_from}`)

  const addressTo = []
  const addressToShort = []

  if (order.city_to) {
    addressTo.push(order.city_to)
    addressToShort.push(order.city_to)
  }

  if (order.address_to) {
    addressTo.push(order.address_to)
    addressToShort.push(order.address_to)
  }

  if (order.entrance_to)
    addressTo.push(`${order.entrance_to} подъезд`)

  if (order.floor_to)
    addressTo.push(`${order.floor_to} эт.`)

  if (order.flat_to)
    addressTo.push(`кв. ${order.flat_to}`)

  const formattedRequestDate = order.request_date && dayjs(order.request_date, "YYYY-MM-DD").format("DD.MM.YYYY")

  return (
    <div className={classes.wrap}>
      <div className={classes.transfer}>
        <div className={classes.transfer_section}>
          {addressFromShort.length &&
            <CopyAddress
              className={classes.copy_address}
              text={addressFromShort.join(", ")}
            />
          }
          <div className={classes.transfer_point}>
            <img src={address_drop_blue} alt=""/>
            <span>Откуда</span>
          </div>
          <div className={classes.transfer_block}>
            <div className={classes.transfer_label}>Место отправления</div>
            <div className={classes.transfer_name}>
              {order.medical_name_from || "Адрес указан вручную"}
            </div>
          </div>
          <div className={classes.transfer_block}>
            <div className={classes.transfer_label}>Адрес</div>
            <div className={classes.transfer_address}>
              {addressFrom.length ? addressFrom.join(", ") : "не указан"}
              {order.lift_from && " (Есть лифт)"}
            </div>
          </div>
          <div className={classes.transfer_block}>
            <div className={classes.transfer_detail}>
              <div className={classes.transfer_detail_item}>
                <div className={classes.transfer_detail_label}>Дата подачи</div>
                <div className={classes.transfer_detail_value}>{formattedRequestDate || "-"}</div>
              </div>
              <div className={classes.transfer_detail_item}>
                <div className={classes.transfer_detail_label}>Время</div>
                <div className={classes.transfer_detail_value}>{order.request_time || "-"}</div>
              </div>
              <div className={classes.transfer_detail_item}>
                <div className={classes.transfer_label}>Бригада</div>
                <div className={classes.transfer_detail_value}>{order.brigade?.brigade || "-"}</div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.transfer_section}>
          {addressToShort.length &&
            <CopyAddress
              className={classes.copy_address}
              text={addressToShort.join(", ")}
            />
          }
          <div className={classes.transfer_point}>
            <img src={address_drop_blue} alt=""/>
            <span>Куда</span>
          </div>
          <div className={classes.transfer_block}>
            <div className={classes.transfer_label}>Место прибытия</div>
            <div className={classes.transfer_name}>
              {order.medical_name_to || "Адрес указан вручную"}
            </div>
          </div>
          <div className={classes.transfer_block}>
            <div className={classes.transfer_label}>Адрес</div>
            <div className={classes.transfer_address}>
              {addressTo.length ? addressTo.join(", ") : "не указан"}
              {order.lift_to && " (Есть лифт)"}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.comment}>
        <div className={classes.comment_title}>Комментарий</div>
        <div className={classes.comment_content}>{order.comment || "-"}</div>
      </div>
      <div className={classes.price}>
        <div className={classes.price_title}>Стоимость</div>
        <div className={classes.price_content}>
          {!order.price && "не указана"}
          {order.price &&
            <div className={classes.price_value}>{`${order.price} руб.`}</div>
          }
          {payment && <div className={classes.price_text}>
            ({payment.name})
          </div>}
        </div>
      </div>
    </div>
  )
}

export default OrderInfo